const PLAY_TRIGGER = {
    HOVER: 'HOVER',
    AUTO: 'AUTO',
    CLICK: 'CLICK',
};
export default PLAY_TRIGGER;
//# sourceMappingURL=playTrigger.js.map